import Box from '@mui/material/Box';

const devOpsWork = [
    { title: 'Products', subTitle: 'Launching Soon.', styles: { backgroundColor: 'bisque'} },
    { title: 'Services',  subTitle: 'Coming Soon.', styles: { color: 'white', backgroundColor: 'firebrick'} },
    { title: 'Technology',  subTitle: 'Coming Soon.', styles: { color: 'white', backgroundColor: 'orange'} }
]

const HomePage = () => {
    return <Box id="Products" display={'flex'} flexDirection={'column'}>
        {devOpsWork.map((dow) => {
            return <Box id={dow.title} key={dow.title}
                className={`container ${dow.classes}`}
                display="flex"
                sx={{
                    alignitems: 'center',
                    flexDirection: { sm: 'column', md: 'row'}
                }}
                style={{...dow.styles}}
            >
                <Box display={'flex'} textAlign="center" flexDirection={'column'}>
                    <Box component="h2">
                        {dow.title}
                    </Box>
                    <Box component="h5" textAlign={'center'}>
                        {dow.subTitle}
                    </Box>
                </Box>
                
            </Box>
        })}
    </Box>
}

export default HomePage;
